var body = document.body;
var window_offsetTop = window.pageYOffset + window.innerHeight;
var count_product = 1;

addEventListener("load", () => {
  stickyBarCollection();
  headerCollection();
  showCollection();
  checkWidthFilter();
  getOffset();
  sortProduct();
});

addEventListener("DOMContentLoaded", () => {
  hiddenCollection();
  checkCollection();
  defaultDirection();
  stickyBarCollection();
  // changeGrid_mb();
  defaultGridLayout();
  countingProduct();
  showCollection();
  loadMore();
});

addEventListener("resize", () => {
  stickyBarCollection();
});

// Safari can split the native hover state between adjacent collection cards.
// Track the hovered card explicitly so both gallery controls belong to it.
document.addEventListener("pointerover", (event) => {
  const card = event.target.closest?.(
    "product-card.rocket-scalpers-product-card--gallery"
  );
  if (card) {
    document
      .querySelectorAll("product-card.rocket-scalpers-product-card--gallery.gallery-hovered")
      .forEach((activeCard) => {
        if (activeCard !== card) activeCard.classList.remove("gallery-hovered");
      });
    card.classList.add("gallery-hovered");
  }
});

document.addEventListener("pointerout", (event) => {
  const card = event.target.closest?.(
    "product-card.rocket-scalpers-product-card--gallery"
  );
  if (card && !card.contains(event.relatedTarget)) {
    card.classList.remove("gallery-hovered");
  }
});

const collectionFilters = document.querySelector(
  ".rocket-collection-grid__filters:not(.active)"
);
let initialPosition = collectionFilters
  ? collectionFilters.offsetTop + collectionFilters.offsetHeight + 24
  : 0;
window.onscroll = function (e) {
  if (screen.width < 768) {
    checkScrollDirection(initialPosition);
  }
  getOffset();
  getOffsetInvited();
};

function wrapFunction() {
  if (
    document.querySelector(".active-facets.active-facets-desktop")
      .childElementCount > 0
  ) {
    document.querySelector("#product-grid").classList.add("filter-active");
    document.querySelectorAll(".collection-banner").forEach((item) => {
      item.classList.add("hidden");
    });
    defaultGridLayout();
    sortProduct();
    showCollection();
    loadMore();
  } else {
    document.querySelector("#product-grid").classList.remove("filter-active");
    document.querySelectorAll(".collection-banner").forEach((item) => {
      item.classList.remove("hidden");
    });
    defaultGridLayout();
    sortProduct();
    showCollection();
    loadMore();
  }
}

function changeGridLayout(evt, gridNum, proNum) {
  let mainGrid = document.querySelector("#product-grid");
  let invitedBrandsGrid = document.querySelector("#invited-brandsgrid");
  var i, tablinks;

  const classGrid = [
    "grid-layout--1",
    "grid-layout--2",
    "grid-layout--4",
    "grid-layout--6",
    "grid-layout--12",
  ];

  tablinks = document.getElementsByClassName(
    "rocket-collection-changeGrid--grid"
  );
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  classGrid.forEach((item) => {
    mainGrid.classList.remove(item);
    mainGrid.setAttribute("data-grid-number-desktop", "");
    if (invitedBrandsGrid) {
      invitedBrandsGrid.classList.remove(item);
      invitedBrandsGrid.setAttribute("data-grid-number-desktop", "");
    }
  });

  mainGrid.classList.add("grid-layout--" + gridNum);
  mainGrid.setAttribute("data-grid-number-desktop", proNum);
  if (invitedBrandsGrid) {
    invitedBrandsGrid.classList.add("grid-layout--" + gridNum);
    invitedBrandsGrid.setAttribute("data-grid-number-desktop", proNum);
  }
  evt.currentTarget.className += " active";
  mainGrid.querySelectorAll("product-card").forEach((item) => {
    item.convertImageSrc();
  });
}

function changeGridLayoutMobile(evt, gridNum) {
  console.log(gridNum);
  let mainGrid = document.querySelector("#product-grid");
  let invitedBrandsGrid = document.querySelector("#invited-brandsgrid");
  var i, tablinks;

  const classGrid = [
    "grid-layout--1",
    "grid-layout--2",
    "grid-layout--4",
    "grid-layout--6",
    "grid-layout--12",
  ];

  tablinks = document.getElementsByClassName(
    "rocket-collection-changeGrid--grid"
  );
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  classGrid.forEach((item) => {
    mainGrid.classList.remove(item);
    if (invitedBrandsGrid) {
      invitedBrandsGrid.classList.remove(item);
    }
  });
  if (invitedBrandsGrid) {
    invitedBrandsGrid.classList.add("grid-layout--" + gridNum);
  }
  mainGrid.classList.add("grid-layout--" + gridNum);
  evt.currentTarget.classList.remove("active");
  mainGrid.querySelectorAll("product-card").forEach((item) => {
    item.convertImageSrc();
  });
  document
    .querySelector(
      ".rocket-collection-changeGrid--mobile .rocket-collection-changeGrid--grid-" + gridNum
    )
    .classList.add("active");
}

/* function toggleSort() {
  let mainSort = document.querySelector("#FacetSortDrawerForm .select");
  mainSort.classList.toggle("active");
} */

function checkSortActive() {
  let mainSort = document.querySelector("#FacetSortDrawerForm .select");

  if (mainSort.classList.contains("active")) {
    mainSort.classList.remove("active");
  } else {
    setTimeout(function() {
      $("#FacetSortDrawerForm .select").addClass("active");
    }, 100);
  }
}

let currentUrl = window.location.href;

document.onclick = function (e) {
  let mainSort = document.querySelector("#FacetSortDrawerForm .select");
  const facetFilters = document.querySelector("label.facet-filters__label--label.rocket-font-helvetica-neue");
  const sortDropdown = document.querySelector(".icon.icon-dropdown-sort");
  if (facetFilters?.contains(e.target) || sortDropdown?.contains(e.target)) {
    checkSortActive();
  } else {
    mainSort.classList.remove("active");
  }

  const body = document.body;
  const classNameToCheck = "template-collection";
  if (body.classList.contains(classNameToCheck)) {
    let newUrl = window.location.href;
    const facetElementInvited = document.querySelector(
      ".grid-collection-invited-scalpers"
    );
    const gridElement = document.getElementById("scalper_grid_2");

    if (newUrl !== currentUrl) {
      if (gridElement) {
        if (facetElementInvited) {
          facetElementInvited.classList.remove("hidden");
        }
        gridElement.classList.add("hidden");
      } else {
        if (facetElementInvited) {
          facetElementInvited.classList.add("hidden");
        }
      }
    } else {
      if (gridElement) {
        if (facetElementInvited) {
          facetElementInvited.classList.add("hidden");
        }
      } else {
        if (facetElementInvited) {
          facetElementInvited.classList.remove("hidden");
        }
      }
    }
  }
};

function defaultGridLayout() {
  const productGrid = document.querySelector("#product-grid");
  if (!productGrid) return;

  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const layoutPrefix = isMobile ? "grid-layout-mobile--" : "grid-layout-desktop--";
  const layoutClass = [...productGrid.classList].find((name) =>
    name.startsWith(layoutPrefix)
  );
  const gridNumber = layoutClass?.replace(layoutPrefix, "");
  if (!gridNumber) return;

  ["1", "2", "4", "6", "12"].forEach((number) => {
    productGrid.classList.remove("grid-layout--" + number);
  });
  productGrid.classList.add("grid-layout--" + gridNumber);

  const control = document.querySelector(
    `.rocket-collection-changeGrid--${isMobile ? "mobile" : "desktop"} .rocket-collection-changeGrid--grid-${gridNumber}`
  );
  if (control) {
    control.click();
  } else {
    productGrid.querySelectorAll("product-card").forEach((item) => {
      item.convertImageSrc?.();
    });
  }
}

function checkCollection() {
  let headerMobile = document.querySelector(".rocket-header__heading__mobile");
  let isSastreria = document.querySelector(".template-sastreria");

  if (headerMobile && !isSastreria) {
    headerMobile.classList.add("rocket-header__heading__mobile--collection");
  }
}

function checkScrollDirection(initialPosition) {
  let positionY = window.pageYOffset;
  if (!this.subbar_not_sticky && !this.subbar_not_sticky_condition) {
    this.subbar_not_sticky_condition = true;
    this.subbar_not_sticky = document.querySelector(
      ".rocket-collection-grid__filters.subbar-not-sticky"
    );
  }

  if (
    !this.subbar_not_sticky ||
    this.subbar_not_sticky.getBoundingClientRect().top < 70
  ) {
    if (this.oldScroll > this.scrollY && positionY > initialPosition) {
      document
        .querySelector(".rocket-collection-grid__filters")
        .classList.add("active");
      document
        .querySelector(".rocket-collection-grid__filters")
        .classList.remove("on-top-active");
    } else if (positionY <= initialPosition) {
      document
        .querySelector(".rocket-collection-grid__filters")
        .classList.remove("on-top-active");
      document
        .querySelector(".rocket-collection-grid__filters")
        .classList.remove("active");
    } else {
      document
        .querySelector(".rocket-collection-grid__filters")
        .classList.remove("active");
      document
        .querySelector(".rocket-collection-grid__filters")
        .classList.add("on-top-active");
    }
  }

  this.oldScroll = this.scrollY;
}

function defaultDirection() {
  let positionY = window.pageYOffset;
  if (window.innerWidth < 768 && positionY > 69) {
    document
      .querySelector(".rocket-collection-grid__filters")
      .classList.add("active");
  } else {
    document
      .querySelector(".rocket-collection-grid__filters")
      .classList.remove("active");
  }
}

function stickyBarCollection() {
  if (
    document.querySelector(".rocket-sticky-bar-collection") &&
    window.innerWidth < 768
  ) {
    document
      .querySelector(".rocket-sticky-bar-collection")
      .append(document.querySelector(".rocket-collection-filter"));
    document
      .querySelector(".rocket-scalpers-sticky-bar-collection")
      .append(document.querySelector(".mobile-facets__wrapper"));
  }
}

function triggerFilter() {
  document.querySelector(".mobile-facets__open-wrapper").click();

  checkWidthFilter();
  resize();
  resizeM();
}

function checkWidthFilter() {
  let filterMenu = document.querySelectorAll(".mobile-facets__details");
  filterMenu.forEach((filterItem) => {
    if (filterItem.querySelector(".mobile-facets__list")) {
      let filterMenu = filterItem.querySelector(".mobile-facets__list");
      let filterMenu_width = filterMenu.offsetWidth;
      let filterMenuContainer = window.innerWidth - 48;

      if (filterMenu_width > 382 && window.innerWidth >= 768) {
        filterItem.classList.add("toggle-filter");
      }

      if (filterMenu_width > filterMenuContainer && window.innerWidth < 768) {
        filterItem.classList.add("toggle-filter");
      }
    }
  });
}

function togglerFilterMenu(el) {
  let parentFilter = el.closest(".mobile-facets__details.toggle-filter");
  if (parentFilter) {
    parentFilter.classList.toggle("active");
  }
}

function changeImageType_product(el) {
  let main = document.querySelector(".rocket-product-grid-container");

  if (main.classList.contains("changeType__product")) {
    main.classList.remove("changeType__product");
    el.classList.remove("active");
  } else {
    main.classList.add("changeType__product");
    main.classList.remove("changeType__model");
    el.classList.add("active");
    document
      .querySelectorAll(".rocket-collection-changeType__model")
      .forEach((item) => {
        item.classList.remove("active");
      });
  }
}

function changeImageType_model(el) {
  let main = document.querySelector(".rocket-product-grid-container");

  if (main.classList.contains("changeType__model")) {
    main.classList.remove("changeType__model");
    el.classList.remove("active");
  } else {
    main.classList.remove("changeType__product");
    main.classList.add("changeType__model");
    el.classList.add("active");
    document
      .querySelectorAll(".rocket-collection-changeType__product")
      .forEach((item) => {
        item.classList.remove("active");
      });
  }
}

function closeFilter() {
  if (document.querySelector(".mobile-facets__open-wrapper")) {
    document.querySelector(".mobile-facets__open-wrapper").click();
  }
}

function openFilter() {
  if (document.querySelector(".mobile-facets__open-wrapper")) {
    document.querySelector(".mobile-facets__open-wrapper").click();
  }
}

function openMenuCollection() {
  if (
    document.querySelector(".header__icon--menu") &&
    window.innerWidth < 768
  ) {
    document.querySelector(".header__icon--menu").click();
  }
}

function headerCollection() {
  if (
    document.querySelector(".rocket-scalpers-sticky-bar-collection") &&
    window.innerWidth < 768
  ) {
    document
      .querySelector(".header-collection-page")
      .classList.add("collection-header");
  }
}

// function changeGrid_mb() {
//   if (window.innerWidth >= 768) {
//     console.log("entraaqui3");
//     document
//       .querySelector(".rocket-product-grid")
//       .classList.add("grid-layout--6");
//     document
//       .querySelector(".rocket-product-grid")
//       .classList.remove("grid-layout--2");
//   } else {
//     console.log("entraaqui6");

//     document
//       .querySelector(".rocket-product-grid")
//       .classList.remove("grid-layout--6");
//     document
//       .querySelector(".rocket-product-grid")
//       .classList.add("grid-layout--2");
//   }
// }

function hiddenCollection() {
  document.querySelector("#product-grid").classList.add("opacity-0");
}

function showCollection() {
  document.querySelector("#product-grid").classList.remove("opacity-0");

  checkWidthFilter();
}

function SortProductScalper() {
  if (window.innerWidth >= 768) {
    let currentGrid_1 = document.querySelectorAll(
      ".grid-collection-scalper-first .grid__item-collection--scalpers"
    );
    currentGrid_1.forEach((item, index) => {
      if (index + 1 > limit_product) {
        item.classList.add("hidden");
      }
    });
  } else {
    let currentGrid_1 = document.querySelectorAll(
      ".grid-collection-scalper-first .grid__item-collection--scalpers"
    );
    currentGrid_1.forEach((item, index) => {
      if (index + 1 > limit_product_mb) {
        item.classList.add("hidden");
      }
    });
  }
}

function sortProduct() {
  if (
    document.querySelector(".grid-collection-scalper-first") &&
    !document.querySelector(".only-show-scalpers")
  ) {
    SortProductScalper();
  }

  if (document.querySelector(".grid-collection-invited-first")) {
    let currentGrid_1_invited = document.querySelectorAll(
      ".grid-collection-invited-first .grid__item-collection--invited"
    );
    currentGrid_1_invited.forEach((item, index) => {
      if (index + 1 > limit_product_invited) {
        item.classList.add("hidden");
      }
    });
  }
}

function loadProduct() {
  let productItems = document.getElementsByClassName(
      "grid__item-collection--scalpers"
    ),
    productItem_length = document.querySelectorAll(
      ".grid__item-collection--scalpers"
    ).length;

  for (i = limit_product; i < productItem_length; i++) {
    if (productItems[i]) {
      productItems[i].classList.remove("hidden");
    }
  }

  document.querySelector(
    ".grid-collection-invited.grid-collection-invited-first"
  ).style.display = "grid";
}

function getOffset() {
  if (document.querySelector(".grid-collection-scalper-first")) {
    var rect = document
      .querySelector(".grid-collection-invited-first")
      ?.getBoundingClientRect();
    if (rect && window.pageYOffset >= rect.top) {
      loadProduct();
      return false;
    }
  }
}

function loadProductInvited() {
  let productItem = document.querySelectorAll(
    ".grid-collection-invited-first .grid__item-collection--invited"
  );

  productItem.forEach((item) => {
    item.classList.remove("hidden");
  });
}

function getOffsetInvited() {
  if (document.querySelector(".grid-collection-invited-first")) {
    var rect = document
      .querySelector(".grid-collection-invited-first")
      .getBoundingClientRect();

    if (window.pageYOffset >= rect.bottom) {
      loadProductInvited();
    }
  }
}

function countingProduct() {
  return;
  document.querySelectorAll(".ProductCount_count").forEach((item) => {
    item.innerHTML = document.querySelectorAll(
      "#ProductGridContainer #product-grid .grid__item-collection"
    ).length;
  });
}

function loadProductByUrl(url, button) {
  if (button.classList.contains("loading")) {
    return;
  }
  button.classList.add("loading");
  fetch(url)
    .then((response) => response.text())
    .then((data) => {
      let html = new DOMParser().parseFromString(data, "text/html");
      let productGrid = button.parentNode;
      let gridSelector =
        button.dataset.gridSelector || ".grid__item-collection";
      if (html.querySelector(gridSelector)) {
        html.querySelectorAll(".grid__item-collection").forEach((item) => {
          if (item.querySelector("product-card")) {
            productGrid.appendChild(item);
          }
        });
        if (html.querySelector(".collection-loadmore-btn")) {
          button.parentNode.removeChild(button);
          productGrid.appendChild(
            html.querySelector(".collection-loadmore-btn")
          );
          loadMore();
        } else {
          button.parentNode.removeChild(button);
        }
      }
    })
    .finally(() => button?.classList.remove("loading"));
}

function loadMore() {
  let observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let url = entry.target.href;
          loadProductByUrl(url, entry.target);
        }
      });
    },
    {
      threshold: 0,
    }
  );
  document.querySelectorAll(".collection-loadmore-btn").forEach((button) => {
    observer.observe(button);
  });
}
